export type Product = {
  slug: string;
  name: string;
  tagline: { it: string; en: string };
  description: { it: string; en: string };
  specs: { it: string; en: string }[];
  meta: { it: string; en: string };
  image: string;
  links?: { label: string; url: string }[];
};

/**
 * Real product copy from the current site. Photos: SATURNO is confirmed
 * (the "Saturno - ambientazione" shot); ARCH uses a placeholder from the
 * product folder — to be swapped with the correct render once confirmed.
 */
export const products: Product[] = [
  {
    slug: 'saturno',
    name: 'SATURNO',
    tagline: { it: 'Lampada in onice', en: 'Onyx lamp' },
    description: {
      it: 'Interamente realizzata in onice, pietra preziosa apprezzata per la sua opacità e traslucenza. Ispirata alle forme geometriche e ai contrasti luminosi degli anelli di Saturno: una forma circolare con un vassoio che diventa elemento di convivialità. Ogni pezzo è unico, con venature irripetibili.',
      en: 'Made entirely of onyx, a precious stone prized for its opacity and translucency. Inspired by the geometry and luminous contrasts of Saturn’s rings: a circular form with a tray that becomes an element of conviviality. Each piece is unique, with one-of-a-kind veining.',
    },
    specs: [
      { it: 'Onice naturale', en: 'Natural onyx' },
      { it: 'Tre versioni: small · medium · big', en: 'Three sizes: small · medium · big' },
      { it: 'Pezzo unico', en: 'One-of-a-kind' },
    ],
    meta: { it: 'In vendita su 1stDibs e Pamono', en: 'Available on 1stDibs and Pamono' },
    image: '/images/product/1e3fb2_5d56773fe09742318679b54c5b87ac60.jpeg',
    links: [
      { label: '1stDibs', url: 'https://www.1stdibs.com/' },
      { label: 'Pamono', url: 'https://www.pamono.com/' },
    ],
  },
  {
    slug: 'arch',
    name: 'ARCH',
    tagline: { it: 'Lampada modulare outdoor', en: 'Modular outdoor lamp' },
    description: {
      it: 'Lampada modulare pensata per integrarsi nelle facciate degli edifici, generando effetti luminosi diversi secondo le combinazioni. Il concept trae ispirazione dall’arco dell’Antica Roma per dare ritmo e movimento alla parete. Utilizzabile anche come elemento freestanding, per appoggio o seduta.',
      en: 'A modular lamp designed to integrate into building façades, creating different lighting effects depending on the combinations. The concept draws inspiration from the arch of Ancient Rome to give rhythm and movement to the wall. It can also be used as a freestanding element — to lean on or sit.',
    },
    specs: [
      { it: 'Outdoor · modulare', en: 'Outdoor · modular' },
      { it: 'Con Yulia Pyanzina', en: 'With Yulia Pyanzina' },
      { it: 'Presentata a Marmomac 2024', en: 'Shown at Marmomac 2024' },
    ],
    meta: {
      it: 'Vincitrice “Let’s design contest” by Cosentino · Domus · ElleDecor · IoArch',
      en: 'Winner of “Let’s design contest” by Cosentino · Domus · ElleDecor · IoArch',
    },
    image: '/images/product/1e3fb2_83a9f43382734f858c38a2d6c9e78957.jpg',
  },
];
